import { useCallback, useEffect, useState } from "react";
import { Mail, MailOpen, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, asList, formatError } from "../../lib/api";
import { fmtDate } from "../../lib/content";

export const Enquiries = ({ onCount }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => {
    api
      .get("/admin/enquiries")
      .then((r) => {
        const list = asList(r.data);
        setItems(list);
        onCount?.(list.filter((x) => !x.read).length);
      })
      .catch((e) => toast.error(formatError(e)));
  }, [onCount]);

  useEffect(() => {
    load();
  }, [load]);

  const toggle = async (it) => {
    await api.patch(`/admin/enquiries/${it.id}?read=${!it.read}`);
    load();
  };
  const remove = async (it) => {
    if (!window.confirm("Delete this enquiry?")) return;
    await api.delete(`/admin/enquiries/${it.id}`);
    load();
  };

  return (
    <div data-testid="enquiries-list" className="space-y-4">
      {items.map((it, i) => (
        <article key={it.id} data-testid={`enquiry-${i}`} className={`border bg-white p-5 ${it.read ? "border-teal/10" : "border-sage"}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-display text-lg text-teal">
                {it.name} {!it.read && <span className="ml-2 rounded-full bg-sage px-2 py-0.5 align-middle text-[10px] uppercase tracking-wider text-teal-ink">New</span>}
              </p>
              <a href={`mailto:${it.email}?subject=Re: ${encodeURIComponent(it.subject)}`} className="text-sm text-teal underline decoration-sage underline-offset-4">{it.email}</a>
              <p className="mt-1 text-xs text-teal/75">
                {it.organisation && `${it.organisation} · `}{it.subject} · {fmtDate(it.created_at)}
              </p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => toggle(it)} className="flex h-10 w-10 items-center justify-center rounded-full border border-teal/20 text-teal hover:bg-mist" aria-label="Toggle read" data-testid={`enquiry-toggle-${i}`}>
                {it.read ? <Mail className="h-4 w-4" /> : <MailOpen className="h-4 w-4" />}
              </button>
              <button onClick={() => remove(it)} className="flex h-10 w-10 items-center justify-center rounded-full border border-red-200 text-red-700 hover:bg-red-50" aria-label="Delete" data-testid={`enquiry-delete-${i}`}>
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
          <p className="mt-4 whitespace-pre-line text-sm leading-relaxed text-teal-ink/90">{it.message}</p>
        </article>
      ))}
      {items.length === 0 && <p className="border border-teal/10 bg-white p-10 text-center text-sm text-teal/70">No enquiries yet.</p>}
    </div>
  );
};
